export const sectionBase = "components_db";
export const sectionPath = "/components_db/";

export const dataSectionBase = "data";
export const dataSection = `${sectionBase}_${dataSectionBase}`
export const dataSectionPath = `${sectionPath}${dataSectionBase}/`

export const componentsSectionBase = "components";
export const componentsSectionPath = `${sectionPath}${componentsSectionBase}/`;

export const presetsSectionBase = "presets";
export const presetsSection = `${sectionPath}_${presetsSectionBase}/`;
export const presetsSectionPath = `${sectionPath}${presetsSectionBase}/`;

